module.exports = __webpack_public_path__ + "img/product_162_1_thumb.a8567b69.jpg";